import React from 'react';
import CourseComponent from 'Components/Card/Components/CourseComponent';
import exSciImg from 'assets/images/exercise-science.jpg';
import imagesPath, { getImageSource } from 'utils/imgUtils';

/* TODO: remove */
function ExerciseScienceCard(props) {
    const { Course: course }  = props.data;

    let img = getImageSource(course.CourseImageUrl) || exSciImg;

    return (
        <CourseComponent course={course} courseImg={img} wrapperModifierClass={course.WrapperModifierClass || "exSci"} />
    )
}

export default ExerciseScienceCard;
